import { type ProductInterface, type ProductPrice } from "@jti/fe-common";
import type { MagentoProductTypeName } from "@jti/magento-types";

export const getPrice = (sku: string, currentVariantSku: string, data: ProductInterface = {}): ProductPrice => {
  const productType: MagentoProductTypeName = data.__typename;

  let minimumPrice;

  if (data) {
    if (productType === "SimpleProduct" || productType === "BundleProduct" || !sku) {
      minimumPrice = data?.price_range?.minimum_price;
    } else if (productType === "ConfigurableProduct" && sku) {
      const product = data?.variants?.find((variant: any) => variant?.product?.sku === currentVariantSku)?.product;

      if (product) {
        minimumPrice = product?.price_range?.minimum_price;
      }
    }
  }

  return {
    price:
      minimumPrice && minimumPrice.regular_price.value !== minimumPrice.final_price.value
        ? minimumPrice.regular_price
        : undefined,
    finalPrice: minimumPrice?.final_price,
  };
};
